import { ProductQuoteV2Dimension, ProductQuoteV3Dimension, StringsWithDataEnumDimension } from '@orus.eu/dimensions'
import type { EsRcphQuote, EsRcphV1QuoteV3, QuoteModelInput } from '@orus.eu/pricing'

export class EsRcphQuoteDimension<NAME extends string> extends ProductQuoteV2Dimension<NAME, EsRcphQuote> {}
export class EsRcphQuoteV3Dimension<NAME extends string> extends ProductQuoteV3Dimension<
  NAME,
  1,
  QuoteModelInput,
  EsRcphV1QuoteV3
> {}

export const esRcphQuoteDimension = new EsRcphQuoteDimension({
  name: 'esRcphQuote',
  displayKeys: { name: 'dimension_name_es_rcph_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esRcphQuoteV3Dimension = new EsRcphQuoteV3Dimension({
  name: 'esRcphQuoteV3',
  displayKeys: { name: 'dimension_name_es_rcph_quote_v3' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  computedAfterTimestamp: 1750686480000,
  inputLocking: undefined,
} as const)

export const esRcphQuoteExclusionDimension = new StringsWithDataEnumDimension({
  name: 'esRcphQuoteExclusion',
  displayKeys: { name: 'dimension_name_es_rcph_quote_exclusion' },
  entries: [['pricing-issue', { label: 'Erreur lors du calcul du prix' }]],
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
